export default {
  setEngagementAnswerGalleries(state, payload) {
    state.engagementAnswerGalleries = payload;
  },
};
